const b64 = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf)))
const unb64 = (str) => Uint8Array.from(atob(str), (c) => c.charCodeAt(0))

export const getOrCreateSalt = (userId) => {
  const storageKey = `dc_vault_salt_${userId}`
  let saltB64 = localStorage.getItem(storageKey)
  if (!saltB64) {
    const salt = crypto.getRandomValues(new Uint8Array(16))
    saltB64 = b64(salt.buffer)
    localStorage.setItem(storageKey, saltB64)
  }
  return unb64(saltB64)
}

export const deriveKey = async (password, salt) => {
  const raw = await crypto.subtle.importKey(
    'raw', new TextEncoder().encode(password), 'PBKDF2', false, ['deriveKey'],
  )
  return crypto.subtle.deriveKey(
    { name: 'PBKDF2', salt, iterations: 100_000, hash: 'SHA-256' },
    raw,
    { name: 'AES-GCM', length: 256 },
    false,
    ['encrypt', 'decrypt'],
  )
}

export const encryptValue = async (cryptoKey, plaintext) => {
  const iv   = crypto.getRandomValues(new Uint8Array(12))
  const data = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    cryptoKey,
    new TextEncoder().encode(plaintext),
  )
  return btoa(JSON.stringify({ iv: b64(iv.buffer), data: b64(data) }))
}

export const decryptValue = async (cryptoKey, encryptedB64) => {
  const { iv, data } = JSON.parse(atob(encryptedB64))
  const plain = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: unb64(iv) },
    cryptoKey,
    unb64(data),
  )
  return new TextDecoder().decode(plain)
}
